<script lang="ts" setup>
import { i18n } from '@apps/main/modules/localization/localizationSetup';
import { useStatsigEventsStore } from '@apps/main/new-desktop/core/stores';

import { TransportType } from '@libs/trip-planner-interfaces';

import { TransportSelector } from '../../../../modules/tranposrtSelector';

const { t } = i18n.global;

interface ItineraryTransportSelectorProps {
  transportType: TransportType;
  disabled: boolean;
  hasUserSelectedTransport?: boolean;
  isUpsellNoTransport?: boolean;
}
const props = defineProps<ItineraryTransportSelectorProps>();

interface ItineraryTransportSelectorEmits {
  (eventName: 'select-transport', value: TransportType): void;
}
const emit = defineEmits<ItineraryTransportSelectorEmits>();

const statsigEventsStore = useStatsigEventsStore();

function selectTransport(transportType: TransportType): void {
  if (transportType === TransportType.None) {
    statsigEventsStore.logExperimentIngredientRemoved('transport');
  }
  emit('select-transport', transportType);
}
</script>

<template>
  <div class="itinerary-transport-selector">
    <TransportSelector
      :transport-type="props.transportType"
      :disabled="props.disabled"
      :initial-option="
        props.hasUserSelectedTransport
          ? t('planner.transport.no_transport_selected')
          : t('planner.transport.add_transport')
      "
      :has-user-selected-transport="props.hasUserSelectedTransport"
      :is-upsell-no-transport="props.isUpsellNoTransport"
      @select="selectTransport"
      @open="statsigEventsStore.logTripOverviewTransportSelectorOpened"
    />
  </div>
</template>
